//Parroquia Trujillo

const munAndrésBelloTrujillo = [
  'Santa Isabel',
  'Araguaney',
  'El Jagüito',
  'La Esperanza',
];
const munBoconó = [
  'Boconó',
  'El Carmen',
  'Mosquey',
  'Ayacucho',
  'Burbusay',
  'General Rivas',
  'Guaramacal',
  'Vega de Guaramacal',
  'Monseñor Jáuregui',
  'Rafael Rangel',
  'San Miguel',
  'San José',
];
const munBolívarTrujillo = ['Sabana Grande', 'Cheregüé', 'Granados'];
const munCandelaria = [
  'Chejendé',
  'Arnoldo Gabaldón',
  'Bolivia',
  'Carrillo',
  'Cegarra',
  'Manuel Salvador Ulloa',
  'San José',
];
const munCarache = [
  'Carache',
  'Cuicas',
  'La Concepción',
  'Panamericana',
  'Santa Cruz',
];
const munEscuque = ['Escuque', 'La Unión', 'Sabana Libre', 'Santa Rita'];
const munJoséFelipeMárquezCañizales = [
  'El Socorro',
  'Antonio José de Sucre',
  'Los Caprichos',
];
const munJuanVicenteCampoElías = ['Campo Elías', 'Arnoldo Gabaldón'];
const munLaCeiba = [
  'Santa Apolonia',
  'El Progreso',
  'La Ceiba',
  'Tres de Febrero',
];
const munMirandaTrujillo = [
  'El Dividive',
  'Agua Santa',
  'Agua Caliente',
  'El Cenizo',
  'Valerita',
];
const munMonteCarmelo = [
  'Monte Carmelo',
  'Buena Vista',
  'Santa María del Horcón',
];
const munMotatán = ['Motatán', 'El Baño', 'Jalisco'];
const munPampán = ['Pampán', 'Flor de Patria', 'La Paz', 'Santa Ana'];
const munPampanito = ['Pampanito', 'La Concepción', 'Pampanito II'];
const munRafaelRangel = [
  'Betijoque',
  'La Pueblita',
  'Los Cedros',
  'José Gregorio Hernández',
];
const munSanRafaeldeCarvajal = [
  'Carvajal',
  'Antonio Nicolás Briceño',
  'Campo Alegre',
  'José Leonardo Suárez',
];
const munSucreTrujillo = [
  'Sabana de Mendoza',
  'El Paraíso',
  'Junín',
  'Valmore Rodríguez',
];
const munTrujillo = [
  'Andrés Linares',
  'Chiquinquirá',
  'Cristóbal Mendoza',
  'Cruz Carrillo',
  'Matriz',
  'Monseñor Carrillo',
  'Tres Esquinas',
];
const munUrdanetaTrujillo = [
  'La Quebrada',
  'Cabimbú',
  'Jajó',
  'La Mesa',
  'Santiago',
  'Tuñame',
];
const munValera = [
  'Juan Ignacio Montilla',
  'La Beatriz',
  'Mercedes Díaz',
  'San Luis',
  'La Puerta',
  'Mendoza',
];

export const esTrujillo = [
  {
    municipio: 'Andrés Bello',
    parroquias: munAndrésBelloTrujillo,
  },
  {
    municipio: 'Boconó',
    parroquias: munBoconó,
  },
  {
    municipio: 'Bolívar',
    parroquias: munBolívarTrujillo,
  },
  {
    municipio: 'Candelaria',
    parroquias: munCandelaria,
  },
  {
    municipio: 'Carache',
    parroquias: munCarache,
  },
  {
    municipio: 'Escuque',
    parroquias: munEscuque,
  },
  {
    municipio: 'José Felipe Márquez Cañizales',
    parroquias: munJoséFelipeMárquezCañizales,
  },
  {
    municipio: 'La Ceiba',
    parroquias: munLaCeiba,
  },
  {
    municipio: 'Miranda',
    parroquias: munMirandaTrujillo,
  },
  {
    municipio: 'Monte Carmelo',
    parroquias: munMonteCarmelo,
  },
  {
    municipio: 'Motatán',
    parroquias: munMotatán,
  },
  {
    municipio: 'Pampán',
    parroquias: munPampán,
  },
  {
    municipio: 'Pampanito',
    parroquias: munPampanito,
  },
  {
    municipio: 'Rafael Rangel',
    parroquias: munRafaelRangel,
  },
  {
    municipio: 'San Rafael de Carvajal',
    parroquias: munSanRafaeldeCarvajal,
  },
  {
    municipio: 'Sucre',
    parroquias: munSucreTrujillo,
  },
  {
    municipio: 'Trujillo',
    parroquias: munTrujillo,
  },
  {
    municipio: 'Urdaneta Trujillo',
    parroquias: munUrdanetaTrujillo,
  },
  {
    municipio: 'Valera',
    parroquias: munValera,
  },
];
